export interface TimelineResource {
  id: string;
  title: string;
  parentId?: string;
  task_guid?: string;
  cloud_platform?: string;
}

export interface TimelineEvent {
  id: string;
  resourceId: string;
  status: number;
  error_count: number;
  start: string;
  end: string;
  scheduled_start_time: string;
  scheduled_end_time: string;
  actual_start_time: string;
  actual_end_time: string;
  type: string;
  vm_id: string;
  cloud_platform: string;
}

export enum EventType {
  VM = "VM",
  Task = "Task",
  Event = "Event",
}

export interface ActiveTimelineEvent {
  status: number;
  error_count: number;
  scheduled_start_time: string;
  scheduled_end_time: string;
  actual_start_time: string;
  actual_end_time: string;
  type: string;
  resourceIds: string[];
  task_id: string;
  vm_id: string;
  cloud_platform: string;
}

export interface ActiveTimelineItem {
  id: string;
  type: EventType;
  item?: TimelineResource | ActiveTimelineEvent;
}

export interface Breadcrumb {
  id: string;
  title: string;
  type: EventType;
  cloud_platform?: string;
}
